/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerChatLoader_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BuyerChatLazy_viewer" | "PdpRespDealerChatLazy_viewer">;
    readonly " $refType": "PdpRespDealerChatLoader_viewer";
};
export type PdpRespDealerChatLoader_viewer$data = PdpRespDealerChatLoader_viewer;
export type PdpRespDealerChatLoader_viewer$key = {
    readonly " $data"?: PdpRespDealerChatLoader_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerChatLoader_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespDealerChatLoader_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isInteractivePdpChat",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isInteractivePdpChat",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BuyerChatLazy_viewer",
          "args": null
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": false,
      "condition": "isInteractivePdpChat",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespDealerChatLazy_viewer",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'ccbb3a12121e8be04b269438ec12abf2';
export default node;
